import React from 'react';
import './AnimatedBG.css';

const AnimatedBG = (props) =>
{
  return (
    <div className="AnimatedBG">
      <div className="line" id="line-0"></div>
      <div className="line" id="line-1"></div>
      <div className="line" id="line-2"></div>
      <div className="line" id="line-3"></div>
      <div className="line" id="line-4"></div>
      <div className="line" id="line-5"></div>
      <div className="line" id="line-6"></div>
      <div className="line" id="line-7"></div>
    </div>
  );
}
export default AnimatedBG;